import { render, staticRenderFns } from "./urlInfo.vue?vue&type=template&id=3bec2d3a&scoped=true"
import script from "./urlInfo.vue?vue&type=script&lang=js"
export * from "./urlInfo.vue?vue&type=script&lang=js"
import style0 from "./urlInfo.vue?vue&type=style&index=0&id=3bec2d3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bec2d3a",
  null
  
)

export default component.exports